import { STATUS_TONE_HEX } from "@racoon/lib";
import type { SiteTone } from "~/shared/lib/pickup-status/site-pins";

// Figma's map pins; the light blue is the pin's own, not the pale badge fill of `assigned`.
export const PIN_HEX: Record<SiteTone, string> = {
  failed: STATUS_TONE_HEX.failed.fill,
  pending: STATUS_TONE_HEX.pending.fill,
  active: STATUS_TONE_HEX.active.fill,
  assigned: "#93C5FD",
  done: STATUS_TONE_HEX.done.fill,
};

export const PIN_W = 24;
export const PIN_H = 29;

const PIN_PATH =
  "M10.608.138c-5.522 0-10 4.379-10 9.78 0 6.432 6.502 9.51 7.317 10.228.832.731 1.519 2.372 " +
  "1.796 3.302a.94.94 0 0 0 .887.69.94.94 0 0 0 .888-.69c.277-.93.964-2.57 1.796-3.303.815-.716 " +
  "7.316-3.795 7.316-10.227 0-5.401-4.477-9.78-10-9.78";

export const pinSvg = (tone: SiteTone, width = PIN_W, height = PIN_H, rim = "#fff") =>
  `<svg width="${width}" height="${height}" viewBox="-1 -1 23 27" style="display:block;overflow:visible">` +
  `<path d="${PIN_PATH}" fill="${PIN_HEX[tone]}" stroke="${rim}" stroke-width="1.5"/>` +
  `<circle cx="10.6" cy="9.9" r="3.6" fill="#fff"/></svg>`;
